import classNames from 'classnames';
import {RoutePath} from 'utils/links';
import {useI18n} from '../../contexts/I18n.client';
import {Container} from '../Container.client';
import {SignupInput} from '../SignupInput.client';
import {HeroAnimation} from './animation/HeroAnimation';

type HeroProps = {
  className?: string;
};

export const Hero = (props: HeroProps) => {
  const {t} = useI18n();

  return (
    <Container
      className={classNames(
        'flex',
        'flex-col',
        'md:flex-row',
        'gap-9',
        'md:gap-0',
        props.className,
      )}
      backgroundGradientStart="light-green"
      backgroundGradientEnd="light-green"
    >
      <div className="md:w-1/2">
        <h1
          className={classNames(
            'font-bold',
            'leading-[110%]',
            'tracking-tighter',
            'text-[2.75rem]',
            'mb-4',
            'mt-16',
            'md:text-7xl',
            'md:mb-6',
            'md:mt-24',
          )}
        >
          {t('heroComponent.title')}
        </h1>

        <p className={classNames('text-xl', 'mb-10', 'md:mb-16')}>
          {t('heroComponent.body')}
        </p>

        <div className="md:max-w-lg">
          <SignupInput
            onSignup={() => {
              window.location.href = RoutePath.AuthSignup;
            }}
          />
        </div>
      </div>

      <div
        className={classNames(
          'md:w-1/2',
          'flex',
          'items-center',
          'justify-center',
        )}
      >
        <div className="max-w-[470px]">
          <HeroAnimation />
        </div>
      </div>
    </Container>
  );
};
